<template>

    <v-modal title="Log Out">
        <template #body>
            <v-alert :message="error" />
            <p>Are you sure you want to log out?</p>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" btn-style="danger" :loading="loading" @click.native="logout">Log Out</v-button>
        </template>
    </v-modal>

</template>

<script>

import AuthApi from '@api/AuthApi'

export default {

    data() {
        return {
            loading: false,
            error: null,
        }
    },

    methods: {

        logout() {
            this.loading = true;
            AuthApi.logout()
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('logout');
                    this.$store.commit('showModal', false);
                    this.$router.push({ name: 'login' });
                }, (error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>
